<!--日+月需量 -->
<template>
	
	 <div class="mydemand">
		 <div class="con">
			   <div class="tree-left">
                <elUnitTree @checkFun='treeCheckItem' :dataList='getDemanList'></elUnitTree>
		      	</div>
				 <div class="right-table">
					 <div class="Files-top">
                        <div class="ic-left">
                        <span>需量曲线</span>
                        </div>
                        <div class="btns">
                        <!-- <el-button  @click="exportButton" type="primary" class="last-el-button">导出</el-button> -->
                        </div>
                     </div>
					 <div class="search-input-btn">
							<div class="input-small">
							<span>日期：</span>
						    	<el-date-picker	v-model="day" type="date"	placeholder="选择日期"  :picker-options="pickerOptions"></el-date-picker>
							</div>
							<el-button type="primary" size="mini" plain @click="newSearchDay" class="search-btn">查询</el-button>
					</div>
					<div class="div-flex" :style="{'height':heights+'px'}">
						<vchart style="height: 100%;background-color: white;" ref='vchart1'></vchart>
					</div>
					 <div class="search-input-btn">
							<div class="input-small">
							<span>日期：</span>
						    	<el-date-picker	v-model="month" type="month"	placeholder="选择日期"  :picker-options="pickerOptions"></el-date-picker>
							</div>
							<el-button type="primary" size="mini" plain @click="newSearchMon" class="search-btn">查询</el-button>
					</div>
					<div class="div-flex" :style="{'height':heights+'px'}">
						<vchart style="height: 100%;background-color: white;" ref='vchart2'></vchart>
						
					</div>
		      	</div>
		 </div>
	 </div>
</template>

<script type="text/javascript">
import elUnitTree from '@/components/module/newTree/elUnitTree.vue'
import vchart from '@/components/module/chart/vchart.vue'
import {findDemandByDay,findDemandByMon} from '../../api/abbNewApi.js'
	function filterZYG(list) {
		list.forEach(data => {
			if(!isempty(data.next) && data.type == "virtualDevice") {
				data.next = data.next.filter(item => {
					log(item.name, item.pkid)
					if(item.pkid == "57a4e5b4-97c8-4d61-856f-b9d990c13489") {
						return false
					} else {
						return true
					}
				})
			} else if(!isempty(data.next)) {
				filterZYG(data.next)
			}
		})
	}
	export default {
		components: {
			vchart,
			elUnitTree
		},
		props: [],
		data() {
			return {
				 heights: document.getElementById('app').clientHeight-640,//屏幕高度 - 导航栏高度
				nowDeviceList: [],
				historyData: {}, //查询出来的历史数据,页码对应内容
				day: new Date(),
				month: new Date(),
				dayOption: {},
				monthOption: {},
				dayData: undefined,
				monthData: undefined,
				demandTree: [],
				demandApptypeList:[264, 265, 266, 267, 268, 269,270,271,272,273,274,275],
				nowDay: 1,
				// dayTimer:new Date(),
				pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now();
				},
				
         
                },
				dayXData:[],
				monXData:[],
			}
		},
		created() {
			debugPage = this
			setTimeout(() => {
				// this.searchDay();
				// this.searchMonth();
			},1500)
		},
		mounted() {
			for(let i = 0;i<=23;i++){
                this.dayXData.push(i>10?i+':00' : "0"+i+':00')
			}
			for(let i = 1;i<=31;i++){
                this.monXData.push(i)
			}
			// 创建一个当前日期的 Date 对象
		    const today = new Date();
			// 设置时间为当天的00:00:00
			today.setHours(0, 0, 0, 0);
			// 获取当天的00:00:00的时间戳（单位为毫秒）
			this.day = today;

	
			const todays = new Date();
			// 设置日期为当月的第一天
			todays.setDate(1);
			todays.setHours(0, 0, 0, 0);
			// 获取当月的第一天的 00:00 分的时间戳（单位为毫秒）
			this.month = todays;
			this.dayOption = this.$refs.vchart1.getDefaultOptions()
			this.dayOption.title.text = '日需量变化曲线'

			this.dayOption.dataZoom = [{
					type: 'slider',
					show: true,
					start: 0,
					end: 100,
					handleSize: 8
				},
				{
					type: 'inside',
					start: 0,
					end: 100
				}
			]
			
			this.monthOption = this.$refs.vchart2.getDefaultOptions()
			this.monthOption.title.text = '月需量变化曲线'
			this.monthOption.dataZoom = [{
					type: 'slider',
					show: true,
					start: 0,
					end: 100,
					handleSize: 8
				},
				{
					type: 'inside',
					start: 0,
					end: 100
				}
			]
			// this.dayOption.grid.bottom = 20
			this.dayOption.grid.bottom = '80'
				this.dayOption.toolbox.right = '2%'
             this.dayOption.legend.bottom = '50px'
             this.dayOption.tooltip = {
            trigger: "axis",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "shadow" // 'shadow' as default; can also be 'line' or 'shadow'
            }
          }
             this.dayOption.xAxis.data = []
			 this.monthOption.grid.bottom = '80'
             this.monthOption.legend.bottom = '50px'
			 this.monthOption.toolbox.right = '2%'
			    this.monthOption.tooltip = {
            trigger: "axis",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "shadow" // 'shadow' as default; can also be 'line' or 'shadow'
            }
          }
			 this.monthOption.xAxis.data = []
			this.$refs.vchart1.setData(this.dayOption, true)
			this.$refs.vchart2.setData(this.monthOption, true)
		},
		destroyed() {},
		computed: {
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			nowVariableList() {

				if(isempty(this.nowDeviceList)) {
					return []
				}

				//当前要显示的变量列表
				var variabelTreeArr = []
				this.nowDeviceList.forEach(device => {
					var variableTree = this.$store.variableStore.getters.getVariableTree(device.no)
					variableTree.forEach(item => {
						item.devicename = device.label
					})
					variabelTreeArr.push(variableTree)
				})

				var tree = []
				variabelTreeArr.forEach(item => {
					tree = tree.concat(item)
				})
				var variableList = []
				for(var i = 0, len = tree.length; i < len; i++) {
					var item = tree[i]
					for(var i1 = 0, len1 = item.next.length; i1 < len1; i1++) {
						var item1 = item.next[i1]
						item1.devicename = item.devicename
						if(this.demandApptypeList.includes(item1.typeNo)) {
							var newItem = copy(item1)
							newItem.name = newItem.name.subByFirstChar(".")
							variableList.push(newItem)
						}
					}
				}
				return variableList
			},
			nowDateText() {
				return this.day.formatByDate('-')
			},
			nowMonthText() {
				return this.month.formatByMonth('-')
			},
			dateList() {
				var year = this.month.getFullYear()
				var month = this.month.getMonth() + 1
				var isLeapYear = (year % 4 == 0 && year % 100 != 0 || year % 400 == 0)
				var list = []
				var max = 32
				if(month == 4 || month == 6 || month == 9 || month == 11) {
					max = 31
				}
				if(isLeapYear && month == 2) {
					max = 30
				}
				if(!isLeapYear && month == 2) {
					max = 29
				}
				for(let i = 1; i < max; i++) {
					list.push({
						text: i + '日',
						value: i
					})
				}
				return list
			},
			getDemanList(){
				let tree=this.$store.deviceStore.getters.getDeman(this.nowUnit.id)
				let list=[]
				if(!isempty(tree)){
					list=[deviceList(tree)]
				}
				return list;
			}
		},
		watch: {
			day(nv, ov) {
				// this.$refs.datepicker.hide()
				// this.searchDay()
			},
			month(nv, ov) {
				this.nowDay = 1
				// this.$refs.datepicker2.hide()
				// this.searchMonth()
			},
			nowVariableList(nv, ov) {
				if(nv.length > 0) {
					// this.searchDay()
					// this.searchMonth()
				}
			},
			dayData(nv, ov) {
				this.reloadChart(copy(nv), 'day')
			},
			monthData(nv, ov) {
				this.reloadChart(copy(nv), 'month')
			},
		},
		methods: {
			treeCheckItem(item){
				this.nowDeviceList = item
				if(item.length != 0 ){
				   this.newSearchDay()
				   this.newSearchMon()
				}
			},
			loadDemandTree() {
			
				
			},
			reloadChart(data, type) {
				var selected = {}
				var legend = []
				var seriesList = []
				if(isempty(data)) {
					//长度为0，清空图表
					if(type == 'day') {
						this.dayOption.series = seriesList
						this.$refs.vchart1.setData(this.dayOption, true)
					} else {
						this.monthOption.series = seriesList
						this.$refs.vchart2.setData(this.monthOption, true)
					}
					return
				}
				// var timeTextList = this.$historyTools.getTimeTextList()
				var timeTextList = this.dayXData
				if(type =='day'){
					timeTextList = this.dayXData
				}else {
                    timeTextList = this.monXData
				}
				for(var i = 0, len = this.nowVariableList.length; i < len; i++) {
					var item = this.nowVariableList[i]
					var itemData = data[item.fromName]
					if(itemData == undefined) {
						itemData = []
					}
					//同时构造数据列
					selected[item.devicename + "_" + item.name] = i > 0 ? false : true
					legend.push({
						name: item.devicename + "_" + item.name,
						icon: 'roundRect'
					})
					seriesList.push({
						name: item.devicename + "_" + item.name,
						type: 'line',
						smooth: true,
						symbol: 'emptyCircle',
						sampling: 'average',
						symbolSize: 6,
						markPoint: {
							data: [{
								name: '最大值',
								type: 'max'
							}]
						},
						data: itemData.map((value, index) => {
							var temp = value
							if(this.$historyTools.isNull(temp)) {
								temp = undefined
							}
							if(type == "day") {
								// return [timeTextList[index], temp]
								return temp
							} else {
								return temp
								// return [index, temp]
							}
						})
					})
					//获取最大值
					var maxValue = this.$historyTools.getMax(itemData, 0)
					seriesList[i].markLine = {
						data: [{
							name: item.name + " 最大需量值",
							yAxis: maxValue,
							label: {
								position: 'middle',
								formatter: item.name + ' 最大需量值:' + maxValue
							},
						}]
					}
				}
				if(type == 'day') {
					this.dayOption.series = seriesList
					this.dayOption.legend.data = legend
					this.dayOption.legend.selected = selected
					this.dayOption.xAxis.data = this.dayXData
					this.$refs.vchart1.setData(this.dayOption, true)
				} else {
					this.monthOption.series = seriesList
					this.monthOption.legend.data = legend
					this.monthOption.legend.selected = selected
					this.monthOption.xAxis.data = this.monXData
					this.$refs.vchart2.setData(this.monthOption, true)
				}
			},
			newSearchDay(){
				if(isempty(this.nowDeviceList)) {
					// this.$dialogMethod.showMessage('请先选择要查询的设备!')
					  this.$message({showClose: true,message: '请先选择要查询的设备',type: 'warning'});
					return
				}
				if(isempty(this.nowVariableList)) {
					// this.$dialogMethod.showMessage('该设备下没有任何需量变量!')
					this.$message({showClose: true,message: '该设备下没有任何需量变量',type: 'warning'});
					return
				}
				var str = ""
				this.nowDeviceList.forEach(item => {
					str += item.no + ','
				})

                var d = {
					'dayTime':this.day.getTime(),
					'deviceNos':str.slice(0, -1)
				}
			    var dayData = {}
				var arrList = []
				findDemandByDay(d).then(res => {	
					if(res.code == 200){
						 res.data.forEach(item => {
							arrList = []
							for (let key in item.dayHistory) {
								arrList.push(item.dayHistory[key])
								}
							dayData[item.deviceName] = arrList
						 })
						 this.dayData = dayData
					}
				})	
			},
            newSearchMon(){
				if(isempty(this.nowDeviceList)) {
					this.$message({showClose: true,message: '请先选择要查询的设备',type: 'warning'});
					return
				}
				if(isempty(this.nowVariableList)) {
					this.$message({showClose: true,message: '该设备下没有任何需量变量',type: 'warning'});
					return
				}
				var str = ""
				this.nowDeviceList.forEach(item => {
					str += item.no + ','
				})

                var d = {
					'dayTime':this.month.getTime(),
					'deviceNos':str.slice(0, -1)
				}
			    var dayData = {}
				var arrList = []
				findDemandByMon(d).then(res => {
					if(res.code == 200){
						 res.data.forEach(item => {
							arrList = []
							for (let key in item.monHistory) {
								arrList.push(item.monHistory[key])
								}
							dayData[item.deviceName] = arrList
						 })
						 this.monthData = dayData
					}
				})	
			},
			searchMonth() {
				if(isempty(this.nowDeviceList)) {
					this.$message({showClose: true,message: '请先选择要查询的设备',type: 'warning'});
					return
				}
				console.log("this.nowVariableList", this.nowVariableList);
				if(isempty(this.nowVariableList)) {
					this.$message({showClose: true,message: '该设备下没有任何需量变量',type: 'warning'});
					return
				}
				//查询指定月份每一天的历史数据
				this.nowDay = this.month.getDate()				
				this.$api.historyApi.getMonthLoadDemandHistory(this.month.getTime(), this.nowDay, this.nowVariableList.map(item => item.fromName)
					.join(','), respon => {
						this.monthData = respon
					}, respon => {
						this.$message({showClose: true,message: '指定日期数据不存在',type: 'warning'});
					})
			},
			searchDay() {
				if(isempty(this.nowDeviceList)) {
					 this.$message({showClose: true,message: '请先选择要查询的设备',type: 'warning'});
					return
				}
				if(isempty(this.nowVariableList)) {
					this.$message({showClose: true,message: '该设备下没有任何需量变量',type: 'warning'});
					return
				}
				var start = new Date(this.day.getFullYear(), this.day.getMonth(), this.day.getDate()).getTime()
				var end = start + 24 * 60 * 60 * 1000 - 1
				var dayKey = this.day.format("yyyyMMdd")
				this.$api.historyApi.searchVariableHistory(this.nowVariableList.map(item => item.fromName).join(','), start, end,
					respon => {
						var result = {}
						for(var i = 0, len = this.nowVariableList.map(item => item.fromName).length; i < len; i++) {
							var nameKey = this.nowVariableList.map(item => item.fromName)[i]
							var value = respon[nameKey]
							if(value == undefined) {
								//没有这天的数据
								result[nameKey] = []
							} else {
								//有数据
								result[nameKey] = value[dayKey].data
							}
						}
						this.dayData = result
					}, respon => {
						this.$message({showClose: true,message: '指定日期数据不存在',type: 'warning'});
					})
			},
			checkDate(item) {
				this.nowDay = item.value
				this.searchMonth()
			}
		}
	}
</script>

<style scoped lang="scss">
	 .mydemand {
     .con{
    width: 100%;
		height: 100%;
		box-sizing: border-box;
		display: flex;
     .public-flex {
    display: flex;
    align-items: center;
    justify-content: center;
  }
    // 正常
  .patrol {
    p {
      width: 8px;
      height: 8px;
      background-color: #0DAE88;
      border-radius: 50%;
      margin-right: 8px;
    }

    span {
      color: #0DAE88;
    }
  }
   // 非正常
  .rush {
    p {
      width: 8px;
      height: 8px;
      background-color: #FF1D1D;
      border-radius: 50%;
      margin-right: 8px;
    }

    span {
      color: #FF1D1D;
    }
  }
  .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 15px;
      }
     .tree-left {
				width: 3rem;
				height: 100%;
				padding: 12px;
				box-sizing: border-box;
				background-color: #fff;
				margin-right: 8px;
				.btns {
					display: flex;
					// justify-content: space-evenly;
					margin-bottom: 8px;

					button {
					margin-right: 12px;
					}

					.el-button--mini {
					padding: 7px 10px !important;
					}

					.el-button+.el-button {
					margin-left: 0px;
					}
				}

				.search {
					display: flex;
					justify-content: center;
					margin-bottom: 12px;
				}

				}
	    .right-table {
			width: calc(100% - 3.08rem);
			height: 100%;
			padding: 12px 20px 20px 20px; 
			box-sizing: border-box;
			background-color: #fff;
      position: relative;
      .mycharts {
        display: flex;
        .charts-left{
          width: 35%;
        }
        .charts-right{
          width: 70%;
        }
      }
		}
   }
  }
</style>